module.exports = __webpack_public_path__ + "static/media/cancel_black.fb0f0a5f.svg";